import FormSidebar from './FormSidebar';
import { UIElement } from '#types/System.types';

export default FormSidebar;

/**
 * Client-defined configuration for form sidebar elements.
 */
export type FormSidebarElementsConfig = {
    /** Label shown in the sidebar segmented control. */
    tabLabel: string;
    /** Default elements rendered when no override exists for a form type. */
    elements: FormSidebarElementDefinition[];
};

/**
 * Definition for a single form sidebar element.
 */
export type FormSidebarElementDefinition = {
    id: string;
    uiElement: UIElement;
};